import {createTheme} from "@material-ui/core";

export default function configureTheme() {
    return createTheme({
        drawerWidth: 240,
    });
};
